import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function ActivityLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/activity").then(r => setRows(r.data.activity)); }, []);
  return (
    <div data-testid="admin-activity">
      <header className="mb-8">
        <div className="label-mono mb-1">/ Actividad</div>
        <h1 className="font-display text-4xl chrome-text">Registro de actividad</h1>
      </header>
      <div className="glass-card chrome-border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="label-mono text-left">
            <tr className="border-b border-white/5">
              <th className="py-3 px-4">Fecha</th><th className="py-3 px-4">Actor</th><th className="py-3 px-4">Acción</th><th className="py-3 px-4">Meta</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={4} className="py-8 text-center text-white/40">Sin actividad</td></tr>}
            {rows.map(r => (
              <tr key={r.id} className="border-b border-white/5">
                <td className="py-3 px-4 label-mono">{new Date(r.ts).toLocaleString()}</td>
                <td className="py-3 px-4 text-white/80">{r.actor}</td>
                <td className="py-3 px-4"><span className="px-2 py-1 rounded-full text-xs border border-cyan-400/40 bg-cyan-400/10 text-cyan-300 font-mono">{r.action}</span></td>
                <td className="py-3 px-4 text-white/50 text-xs font-mono">{JSON.stringify(r.meta)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
